import { combineReducers, configureStore } from '@reduxjs/toolkit'
import commonSlice from './Slices/commonSlice'
import dashboardSlice from './Slices/dashboardSlice'
import abhaSlice from './Slices/abhaSlice'
import userSlice from './Slices/userSlice'
import TicketSlice from './Slices/TicketSlice'

const reducers = combineReducers({
        common: commonSlice,
        user: userSlice,
        abhaCreated: abhaSlice,
        dashboard: dashboardSlice,
        Ticket: TicketSlice
})
const reducerProxy = (state, action) => {
    if (action.type === 'LOGOUT') {
        return reducers(undefined, action);
    }
    return reducers(state, action);
}
const store = configureStore({
    reducer: reducerProxy
});
export default store